export default __webpack_public_path__ + "static/media/doctor-center.c97d1874.svg";